/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useChaptersList } from '@api/hooks';

import SearchableEntitySelect from '../SearchableEntitySelect';

const ChapterSelect = React.forwardRef(({ placeholder = 'Type to search a chapter', ...props }, ref) => (
  <SearchableEntitySelect
    useList={useChaptersList}
    formatLabel={({ title }) => title}
    ref={ref}
    placeholder={placeholder}
    {...props}
  />
));

export default ChapterSelect;
